import { render, staticRenderFns } from "./QrFeedback.vue?vue&type=template&id=6a503ca7&"
import script from "./QrFeedback.vue?vue&type=script&lang=js&"
export * from "./QrFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports